import React from "react";
import ModalComponent from "./modal.component";

export default function ModalContainer({ isOpen, handleClose, maxWidth, ...props }) {
  return (
    <ModalComponent isOpen={isOpen} handleClose={handleClose} maxWidth={maxWidth} {...props} />
  );
}
